<template>
    <div>
        <b-button
            class="mb-1"
            variant="default"
            :href="`/app/property/setup/details/${params.data.id}`"
        >
            <font-awesome-icon :icon="['fas', 'pen-to-square']" />
        </b-button>
        <b-button
            v-if="isPropertyDelete"
            class="mb-1"
            variant="default"
            @click="$bvModal.show(deleteModalId)"
        >
            <font-awesome-icon :icon="['fas', 'trash']" />
        </b-button>
        <modal
            :id="deleteModalId"
            title="Delete Room Type"
            @ok="deleteRoomtype"
        >
            Are you sure want to delete this room type?
        </modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Modal from '../../../generic/modal/modal.vue';
export default {
    components: { Modal },
    computed: {
        ...mapGetters('setupPropertyStore', ['initialData']),
        deleteModalId() {
            return 'delete-roomtype-modal' + this.params.data.id;
        },
        isPropertyDelete() {
            return (
                this.initialData && this.initialData.permissions.property_delete
            );
        },
    },
    methods: {
        deleteRoomtype() {
            this.params.onDelete(this.params.data.id, this.deleteModalId);
        },
    },
};
</script>
